import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Children } from "react";
import { useDeviceType } from "@vfit/shared/hooks";
import { HamburgerMenu, Logo, Search, User } from "@vfit/ui/icons";
import { ActionsMenu, ActionsMenuList, IconButton, LogoWrapper, MainContainer } from "./head.style";
import SearchBox from "../../../components/SearchBox/SearchBox";
import BlackHeader from "../../../components/Head/head";
var icons = {
    search: /*#__PURE__*/ _jsx(Search, {}),
    profile: /*#__PURE__*/ _jsx(User, {}),
    hamburgerMenu: /*#__PURE__*/ _jsx(HamburgerMenu, {})
};
var Head = function(param) {
    var actionsMenu = param.actionsMenu, openMenu = param.openMenu, homeRedirect = param.homeRedirect, customerType = param.customerType;
    var ref = useDeviceType(), isTablet = ref.isTablet, isMobile = ref.isMobile;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BlackHeader, {
                customerType: customerType || [],
                otherInfo: []
            }),
            /*#__PURE__*/ _jsxs(MainContainer, {
                children: [
                    /*#__PURE__*/ _jsx(LogoWrapper, {
                        children: /*#__PURE__*/ _jsx("a", {
                            href: homeRedirect,
                            children: /*#__PURE__*/ _jsx(Logo, {})
                        })
                    }),
                    /*#__PURE__*/ _jsxs(ActionsMenu, {
                        children: [
                            /*#__PURE__*/ _jsx(SearchBox, {}),
                            Children.toArray(actionsMenu.map(function(action) {
                                if (!action.url || !icons[(action === null || action === void 0 ? void 0 : action.category) || ""]) return null;
                                return /*#__PURE__*/ _jsx(ActionsMenuList, {
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: action.url,
                                        children: icons[action.category]
                                    })
                                });
                            })),
                            (isTablet || isMobile) && /*#__PURE__*/ _jsx(IconButton, {
                                "aria-label": "menu",
                                onClick: function() {
                                    return openMenu("fade-in");
                                },
                                children: /*#__PURE__*/ _jsx(HamburgerMenu, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default Head;
